import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * Modal para que el jefe proporcione un comentario al rechazar objetivos del primer periodo 1Q.
 *
 * Props:
 * - showFormModal: boolean -> controla la visibilidad del modal.
 * - setShowFormModal: function -> función para actualizar la visibilidad desde el padre.
 * - onReject: function -> callback que recibe (isApproved:boolean, comment:string).
 *
 * Comportamiento:
 * - Mantiene el comentario en estado local.
 * - Al confirmar (Enviar) llama a onReject(false, comment) y cierra el modal.
 */
const FirstPeriodRejectObjectivesModal = ({ showFormModal, setShowFormModal, onReject }) => {
    // Estado local para el comentario que el jefe escribe
    const [comment, setComment] = useState("");

    // Manejador que envía el comentario al callback del padre y cierra el modal
    const handleReject = () => {
        onReject(false, comment);
        setShowFormModal(false);
    };

    return (
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)} size="md" centered>
            <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                    Rechazar Objetivos
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* Breve instrucción para el usuario */}
                <p>Proporcione un comentario para que el evaluado sepa que debe ajustar en sus objetivos.</p>

                {/* Área de texto controlada para recoger el comentario */}
                <textarea
                    rows={4}
                    className="form-control mt-3"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </Modal.Body>

            <Modal.Footer>
                {/* Botón para cancelar y cerrar el modal sin enviar */}
                <Button variant="secondary" className="rounded-pill" onClick={() => setShowFormModal(false)}>
                    Cancelar
                </Button>

                {/* Botón para enviar el comentario y ejecutar la acción de rechazo */}
                <Button variant="primary" className="rounded-pill" onClick={handleReject}>
                    Enviar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FirstPeriodRejectObjectivesModal;